export default "__VITE_ASSET__onW3WK5Z__"